export default {
  name: 'Nome',
  actions: 'Ações',
  'list.entities.name_pending': 'Tipos de pendências',
  'list.entities.name_serviceTransport': 'Tipos de transporte',
  'list.entities.name_rescheduling': 'Motivos de reagendamento',
  'list.entities.name_approved': 'Motivos de aprovação',
  'list.entities.name_disapproved': 'Motivos de reprovação',
  'list.entities.name_unproductive': 'Motivos de improdutividade',
  'list.entities.name_canceled': 'Motivos de cancelamento',
  'list.entities.name_checkListCategory': 'Categorias dos questionários',
  'list.entities.name_assetType': 'Tipos de ativos',
  'list.entities.name_pause': 'Motivos de pausa',
  'list.entities.name_closing': 'Motivos de encerramento',

  title_modal_pending_edit: 'Editar Tipo de pendência',
  title_modal_serviceTransport_edit: 'Editar Tipo de transporte',
  title_modal_rescheduling_edit: 'Editar Motivo de reagendamento',
  title_modal_approved_edit: 'Editar Motivo de aprovação',
  title_modal_disapproved_edit: 'Editar Motivo de reprovação',
  title_modal_unproductive_edit: 'Editar Motivo de improdutividade',
  title_modal_canceled_edit: 'Editar Motivo de cancelamento',
  title_modal_checkListCategory_edit: `Editar Categorias dos questionários`,
  title_modal_assetType_edit: `Editar Tipo de ativo`,
  title_modal_closing_edit: `Editar Motivo de encerramento`,

  title_modal_pending: 'Novo Tipo de pendência',
  title_modal_serviceTransport: 'Novo Tipo de transporte',
  title_modal_rescheduling: 'Novo Motivo de reagendamento',
  title_modal_approved: 'Novo Motivo de aprovação',
  title_modal_disapproved: 'Novo Motivo de reprovação',
  title_modal_unproductive: 'Novo Motivo de improdutividade',
  title_modal_canceled: 'Novo Motivo de cancelamento',
  title_modal_checkListCategory: `Nova Categorias dos questionários`,
  title_modal_assetType: 'Novo Tipo de ativo',
  title_modal_closing: 'Novo Motivo de encerramento',
  selectCategories: 'Seleção de categorias'
}
